export default __webpack_public_path__ + "static/media/z040ma0c.83128a66.mp3";